import { Component } from '@angular/core';

@Component({
  selector: 'app-error-not-found',
  imports: [],
  templateUrl: './error-not-found.component.html',
  styleUrl: './error-not-found.component.css'
})
export class ErrorNotFoundComponent {

}
